// extracted by mini-css-extract-plugin
export var cardIcon = "_au-4";
export var checkboxCard = "_au-0";
export var checkboxCardSelected = "_au-3";
export var disabled = "_au-1";
export var outerBorder = "_au-2";
export var spacerMedium = "_au-7";
export var spacerSmall = "_au-6";
export var spacerXsmall = "_au-5";